(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-loyalty"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eh-loyalty')) {
    class EhLoyalty extends HTMLElement {
      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('[data-refresh]')?.addEventListener('click', () => window.location.reload(), options);
        this.querySelector('[data-open-rewards]')?.addEventListener('click', event => {
          const launcher = document.getElementById('appstle-loyalty-button');
          if (launcher) {
            event.preventDefault();
            launcher.click();
          }
        }, options);
        if (!this.dataset.customer) return;
        document.addEventListener('AppstleLoyalty:AppliedDiscountCode', () => {
          clearInterval(this.timer);
          this.setState('stale');
        }, options);
        this.startedAt = Date.now();
        if (!this.readBalance()) {
          this.timer = setInterval(() => {
            if (this.readBalance()) clearInterval(this.timer);
            else if (Date.now() - this.startedAt >= 15000) {
              clearInterval(this.timer);
              this.setState('unavailable');
            }
          }, 500);
        }
      }
      readBalance() {
        const config = window._ALConfig;
        if (!config || String(config.customerId) !== this.dataset.customer) return false;
        if (config.widget_setting?.hidePointsBalance === true) return false;
        const value = config.customerLoyalty?.availablePoints;
        if (typeof value !== 'number' && typeof value !== 'string') return false;
        if (typeof value === 'string' && !value.trim()) return false;
        const points = Number(value);
        if (!Number.isFinite(points) || points < 0) return false;
        this.querySelector('[data-points]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 20 }).format(points);
        this.setState('ready');
        return true;
      }
      setState(state) {
        ['loading', 'ready', 'unavailable', 'stale'].forEach(name => {
          const element = this.querySelector('[data-' + name + ']');
          if (element) element.hidden = name !== state;
        });
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        this.connected = false;
      }
    }
    customElements.define('eh-loyalty', EhLoyalty);
  }

  } catch(e) { console.error(e); }
})();
})();
